import { render, staticRenderFns } from "./trainingCourse.vue?vue&type=template&id=5f0a6b57&scoped=true"
import script from "./trainingCourse.vue?vue&type=script&lang=js"
export * from "./trainingCourse.vue?vue&type=script&lang=js"
import style0 from "./trainingCourse.vue?vue&type=style&index=0&id=5f0a6b57&prod&lang=less&scoped=true"
import style1 from "./trainingCourse.vue?vue&type=style&index=1&id=5f0a6b57&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a6b57",
  null
  
)

export default component.exports